"use strict";

import Swiper from "swiper";
import { Navigation, Pagination } from "swiper/modules";

document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".apartment-item").forEach((item) => {
        const slider = item.querySelector(".plan-slider");
        if (!slider) return;

        const floorImages = item.querySelectorAll(".plan__floor img");
        const levelItems = item.querySelectorAll(".plan__level ul li");
        const paginationEl = item.querySelector(".plan__navigation-pagin ul");

        const swiper = new Swiper(slider, {
            modules: [Navigation, Pagination],
            slidesPerView: 1,
            initialSlide: 1,
            speed: 500,
            navigation: {
                nextEl: item.querySelector(".plan__navigation-right"),
                prevEl: item.querySelector(".plan__navigation-left"),
            },
            pagination: {
                el: paginationEl,
                clickable: true,
                bulletClass: "swiper-pagination-bullet",
                bulletActiveClass: "swiper-pagination-bullet-active",
                renderBullet: function (index, className) {
                    return `<li class="${className}">${index - 1}</li>`;
                }
            },
            on: {
                init: function () {
                    syncFloorAndLevels(this.realIndex, floorImages, levelItems);
                },
                slideChange: function () {
                    syncFloorAndLevels(this.realIndex, floorImages, levelItems);
                }
            }
        });
    });
});

function syncFloorAndLevels(activeIndex, floorImages, levelItems) {
    const targetFloorIndex = (activeIndex - 1).toString();


    floorImages.forEach((img) => {
        if (img.getAttribute("data-index") === targetFloorIndex) {
            img.style.display = "block";
        } else {
            img.style.display = "none";
        }
    });

    levelItems.forEach((li, idx) => {
        if (idx === activeIndex) {
            li.classList.add("active");
            li.style.display = "block";
        } else {
            li.classList.remove("active");
            li.style.display = "none";
        }
    });
}